module.exports = __webpack_public_path__ + "media/images/official/ogimage-d6a062c107cd7f725690ca2b5fea2ec3.jpg";